import { FormArray, FormControl, ValidatorFn } from '@angular/forms';
import { UploadForm } from '@bo-client/shared/models/documentDto';

export const RegexToCheckEMail =
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,36}))$/;

export const RegexToCheckPassword = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{6,})/;

export const RegexToCheckMaStrNumber = /^[aA][bB][rR][a-zA-Z0-9]{12}$/;
export const RegexToCheckModuleMaStrNumber = /^[sS][eE][eE]9[0-9]{11}$/;

/**
 * Validator, der überprüft, ob der Form-Array mindestens ein Dokument enthält.
 * @param control FormArray, der die UploadForm-Elemente enthält
 */
export const requireDocumentsValidator: ValidatorFn = (control: FormArray<UploadForm>) => {
  return !!control.length ? null : { required: true };
};

/**
 * Validator, der überprüft, ob das eingegebene Datum mindestens dem heutigen Datum entspricht.
 * @param control FormControl mit einem Date-Wert
 */
export const minDateValidator: ValidatorFn = (control: FormControl<Date>) => {
  if (!control.value) return null;
  const date = new Date(control.value);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return date.getTime() < today.getTime() ? { minDate: true } : null;
};

/**
 * Parametrisierte Variante von {@link minDateValidator} für ein frühestes erlaubtes Datum, das nicht
 * heute ist — etwa der erste mögliche Durchführungstermin aus der Vorlaufzeit des Mandanten.
 * @param minDate Frühestes erlaubtes Datum
 */
export const minDateFromValidator =
  (minDate: Date): ValidatorFn =>
  (control: FormControl<Date>) => {
    if (!control.value) return null;
    return new Date(control.value).getTime() < minDate.getTime() ? { minDate: true } : null;
  };
